import dayjs from '../../utils/dayjs';

/** Returns one of `not-expired` | `expiring-soon` | `expired` for DD/MM/YYYY strings — matches dashboard rules. */
export function getPlanExpiryStatus(expiry) {
  if (!expiry) return null;

  const d = dayjs(expiry, 'DD/MM/YYYY');
  if (!d.isValid()) return null;

  if (dayjs().isAfter(d)) return 'expired';

  if (d.diff(dayjs(), 'month', true) > 1) return 'not-expired';

  return 'expiring-soon';
}

export const PLAN_EXPIRY_STATUS_LABEL = {
  'not-expired': 'Subscription active',
  'expiring-soon': 'Expires soon',
  expired: 'Expired — renew required'
};
